import React, { FC, useMemo } from 'react';
import { CustomScalarSpreadsheet } from 'components';
import ScalarSpreadsheet from 'components/ScalarSpreadsheet';
import { getObjectValue, getStringValue } from 'utilities';
import { ModifiedPresentEquityProps } from './types';

const ModifiedPresentEquity: FC<ModifiedPresentEquityProps> = props => {
  const { isLoading, isSaving, onChange, spreadsheets, workbook, format, formatDispatch } = props;
  const { presentValueSheet: presentValueSpreadsheet } = getObjectValue(spreadsheets);

  // Create Modified Present Equity Value Sheet props
  const presentValueSheetProps = useMemo(() => {
    if (presentValueSpreadsheet) {
      return {
        ...presentValueSpreadsheet,
        format,
        formatDispatch,
        key: getStringValue(presentValueSpreadsheet?.name),
        onChange,
        sheet: presentValueSpreadsheet,
        workbook,
      } as unknown as typeof ScalarSpreadsheet;
    }

    return null;
  }, [presentValueSpreadsheet, format, formatDispatch, onChange, workbook]);

  return <CustomScalarSpreadsheet {...presentValueSheetProps} isLoading={isLoading} isSaving={isSaving} />;
};

export default ModifiedPresentEquity;
